import React, { useState } from "react";
import { Store } from "lucide-react";

// Rosto de quem está na mesa: a foto do cadastro quando existe (é rara — a
// maioria dos clientes não tem) e, sem ela, a inicial do nome num círculo.
// `balcao` é o pedido que o garçom lançou pelo painel, que não tem dono.
export default function Avatar({ nome, foto, fotoDe, tamanho = 32, balcao = false, className = "" }) {
  const [quebrou, setQuebrou] = useState(false);
  const medida = { width: tamanho, height: tamanho, fontSize: Math.round(tamanho * 0.42) };
  const base = `rounded-full shrink-0 flex items-center justify-center overflow-hidden ${className}`;

  if (balcao) {
    return (
      <span className={`${base} bg-zinc-500/15 text-zinc-500`} style={medida} aria-hidden>
        <Store style={{ width: tamanho * 0.5, height: tamanho * 0.5 }} />
      </span>
    );
  }
  const src = foto && !quebrou ? (fotoDe ? fotoDe(foto) : foto) : null;
  if (src) {
    return (
      <span className={base} style={medida}>
        <img src={src} alt={nome || ""} className="w-full h-full object-cover" onError={() => setQuebrou(true)} />
      </span>
    );
  }
  const inicial = String(nome || "?").trim().charAt(0).toUpperCase() || "?";
  return (
    <span className={`${base} bg-primary/15 text-primary font-black`} style={medida} aria-hidden>
      {inicial}
    </span>
  );
}
